import * as React from 'react';

import SaleViewMobile from '~/apps/pos/mobile/containers/sales/SaleViewMobile';
import BaseSaleHistoryLayout from "~/apps/pos/mobile/pages/BaseSaleHistoryLayout";

export default function ({ saleId }) {
  return (
    BaseSaleHistoryLayout(
      <SaleViewMobile saleId={saleId} />
    )
  );
};
